import '../Button.css';
import { defineComponent as m, computed as a, openBlock as n, createBlock as c, resolveDynamicComponent as b, normalizeClass as s, withCtx as y, createElementBlock as h, createCommentVNode as d, renderSlot as k } from "vue";
import { _ as g } from "../_plugin-vue_export-helper-CHgC5LLL.js";
const B = /* @__PURE__ */ m({
  __name: "Button",
  props: {
    size: { default: "md" },
    variant: { default: "primary" },
    block: { type: Boolean, default: !1 },
    type: { default: "button" },
    loadingWithText: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    pill: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    classes: { default: () => ({}) },
    component: { default: "button" },
    href: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["onClick"],
  setup(i, { emit: r }) {
    const l = i, u = a(() => {
      var o;
      let e = "";
      const t = [];
      return l.rounded ? (e = `icon-${l.size}`, t.push("icon")) : e = `size-${l.size}`, [
        ...t,
        e,
        "t-btn",
        `t-btn-${l.variant}`,
        `rounded-${l.pill ? "full" : "md"}`,
        { block: !l.rounded && l.block, "cursor-not-allowed": l.disabled, "btn-link": l.href },
        ((o = l.classes) == null ? void 0 : o.container) || ""
      ];
    }), f = r, p = a(() => l.href ? "a" : l.component || "div");
    return (e, t) => (n(), c(b(p.value), {
      href: e.href || "",
      class: s(u.value),
      type: e.type,
      disabled: e.loading || e.disabled || e.loadingWithText,
      role: e.href ? "link" : "button",
      onClick: t[0] || (t[0] = (o) => !(e.loading || e.disabled || e.loadingWithText) && f("onClick"))
    }, {
      default: y(() => {
        var o;
        return [
          e.loading || e.loadingWithText ? (n(), h("span", {
            key: 0,
            class: s(["loading loading-spinner w-5 h-5", { "mr-2": !e.loading }, (o = e.classes) == null ? void 0 : o.loader])
          }, null, 2)) : d("", !0),
          e.loading ? d("", !0) : k(e.$slots, "default", { key: 1 }, void 0, !0)
        ];
      }),
      _: 3
    }, 8, ["href", "class", "type", "disabled", "role"]));
  }
}), z = /* @__PURE__ */ g(B, [["__scopeId", "data-v-09480cf0"]]);
export {
  z as default
};
//# sourceMappingURL=Button.esm.js.map
